import { render, staticRenderFns } from "./ListProductShops.vue?vue&type=template&id=2583a2d4"
import script from "./ListProductShops.vue?vue&type=script&lang=js"
export * from "./ListProductShops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports